import { Component, HostBinding, Input } from '@angular/core';
import { IBenefit } from './interfaces/benefit.interface';

@Component({
  selector: 'app-akky-pro-benefits',
  templateUrl: './akky-pro-benefits.component.html',
  styleUrls: ['./akky-pro-benefits.component.css'],
  host: {
    class: 'd-flex aling-items-center justify-content-center'
  }
})
export class AkkyProBenefitsComponent
{
  @Input({required: true}) public backgroundColor!: string;

  @HostBinding('style.background-color') public get setBackground(): string
  {
    return this.backgroundColor;
  }

  @HostBinding('style.min-height') public minHeight = '554px';

  protected readonly benefits: IBenefit[] = [
    {
      iconName: 'circle-percent.svg',
      text: 'Precios preferenciales por volumen en Dominios y Servicios Digitales.'
    },
    {
      iconName: 'circle-star.svg',
      text: 'Acceso anticipado a ofertas y promociones.'
    },
    {
      iconName: 'shopping-heart.svg',
      text: 'Adquiere productos exclusivos para mayoristas.'
    },
    {
      iconName: 'material-graphics.svg',
      text: 'Materiales gráficos e información detallada de apoyo por producto.'
    }
  ];

}
